export default __webpack_public_path__ + "static/rm-e377bb4eb26bad7678dc0051fa11fbd1.png";